import React from "react";

export default function RegisterIcon({
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  onClick,
  className,
  style = {},
  ...rest
}) {
  const mergedStyle = Object.assign(
    { width: size, height: size, cursor: onClick ? "pointer" : undefined },
    style
  );

  const svgProps = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    fill: "none",
    stroke: color,
    strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    onClick,
    className,
    style: mergedStyle,
    ...rest
  };

  return React.createElement(
    "svg",
    svgProps,

    React.createElement("path", { d: "M2 6h4" }),
    React.createElement("path", { d: "M2 10h4" }),
    React.createElement("path", { d: "M2 14h4" }),
    React.createElement("path", { d: "M2 18h4" }),
    React.createElement("rect", { width: 16, height: 20, x: 4, y: 2, rx: 2 }),
    React.createElement("path", { d: "M16 2v20" })
  );
}
